import React, { useEffect, useContext } from 'react';
import qs from 'qs';
import { LoadingBounce } from '@michelin/acid-components';
import Oauth from '../../providers/Auth0Provider/Auth0Provider';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
import { CentralProviderErrorTypes } from '../../constants/centralProviderErrors';
export function Login(props) {
    var centralProviderContext = useContext(CentralProviderContext);
    var handleSubmit = function (event) {
        if (props.redirectToPreviousRoute) {
            sessionStorage.setItem('redirect', "".concat(window.location.pathname.replace(/^\/+/g, '')).concat(window.location.hash || ''));
        }
        if (event)
            event.preventDefault();
        Oauth.fullAuthorize();
    };
    useEffect(function () {
        var location = window.location;
        if (location.hash.includes('error=login_required')) {
            Oauth.fullAuthorize();
        }
        else if (location.hash.includes('error=consent_required')) {
            Oauth.requestConsent();
        }
        else if (location.hash.includes('error=unauthorized')) {
            centralProviderContext.setError({ key: CentralProviderErrorTypes.CALLBACK_ERROR_UNAUTHORIZED });
        }
        if (!location.pathname.includes('callback') && !qs.parse(location.hash).access_token)
            handleSubmit();
    }, []);
    return (React.createElement("div", { style: {
            width: '100%',
            height: '100%',
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        } },
        React.createElement(LoadingBounce, { style: { height: '100vh' } })));
}
//# sourceMappingURL=Login.js.map